import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export type TBulkMessageJobType = 'SEND_BULK_CHAT_MESSAGE' | 'SEND_BULK_GENERAL_THREADS_MESSAGE';

export type TBulkMessageJobListItem = {
  id: string;
  jobType: TBulkMessageJobType;
  isJobCompleted: boolean;
  totalRows: number | null;
  processedRows: number | null;
  successCount: number | null;
  failureCount: number | null;
  startedAt: string | null;
  finishedAt: string | null;
  message: string | null;
};

type TBulkMessageJobListResponse = {
  jobs: TBulkMessageJobListItem[];
};

const ALL_BULK_MESSAGE_JOB_TYPES: TBulkMessageJobType[] = [
  'SEND_BULK_CHAT_MESSAGE',
  'SEND_BULK_GENERAL_THREADS_MESSAGE',
];

export function useBulkMessageJobs(
  jobTypes: TBulkMessageJobType[] = ALL_BULK_MESSAGE_JOB_TYPES
) {
  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    mutate: KeyedMutator<unknown>;
    error: unknown;
    data: TBulkMessageJobListResponse;
    isLoading: boolean;
  } = useSWR(
    `job/search?jobTypes=${jobTypes.join(',')}`,
    SWRFetcher({ method: 'GET' })
  );

  return {
    data,
    error,
    mutate,
    isLoading,
  };
}
